import type { RouteRecordRaw } from 'vue-router';

import { Layouts } from '@/layouts/constants/Layout';
import { RouteNames } from '@/router/constants/routeName';

const fleetRoutes: RouteRecordRaw[] = [
  {
    path: '/fleet-controls',
    name: RouteNames.FleetControls,
    component: () => import('@/views/fleet-control/FleetControlOverview.vue'),
    meta: {
      layout: Layouts.MODERN,
    },
  },
  {
    path: '/fleet-controls/deprecated',
    name: RouteNames.DeprecatedFleetControls,
    component: () => import('@/views/deprecated/AllFleetControlView.vue'),
  },
  {
    path: '/endpoint-tags',
    name: RouteNames.EndpointTags,
    component: () => import('@/views/endpoint-tags/EndpointTagsOverview.vue'),
    meta: {
      layout: Layouts.MODERN,
    },
  },
  {
    path: '/endpoint-tags/deprecated',
    name: RouteNames.DeprecatedEndpointTags,
    component: () => import('@/views/deprecated/EndpointTagsView.vue'),
  },
];

export default fleetRoutes;
